import React from 'react';
import MetaTags from './components/MetaTags';
import { AppBar } from './components/AppBar';
import Footer from './components/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail } from "react-icons/md";

const ContactUs = () => {
  return (
    <div>
      <MetaTags
        title="Contact Us | Alagar Crackers Sivakasi | Wholesale & Retail Fireworks"
        type="website"
        siteName="alagarcrackers.com"
        url="https://alagarcrackers.com/contactus"
        keywords="Contact Us, Alagar Crackers, Sivakasi Crackers, Wholesale Crackers Shop Sivakasi"
        description="Contact Alagar Crackers Sivakasi for wholesale & retail crackers order enquiry."
        revisitAfter="10 Days"
      />
      <AppBar />
      <img src={require('../assets/images/banner/banner_seven.jpg')} className='img-fluid w-100' alt='Contact Alagar Crackers' />
      
      <div className='padding'>
        <Container>
          <Row className='justify-content-center'>
            <Col lg={12} className='text-center mb-4'>
              <h1 className='bold lg-font color-red'>Get In Touch With Us</h1>
              <p className='regular text-muted' style={{ fontSize: '17px' }}>
                We are always available to help you with your crackers selection and bulk orders.
              </p>
            </Col>

            <Col lg={4} md={6} className='py-3'>
              <div className='box'>
                <div className='box-icon'>
                  <PiMapPinSimpleAreaBold size={36} />
                </div>
                <h4 className='bold text-dark mb-2'>Visit Our Store</h4>
                <div className='regular text-muted' style={{ lineHeight: 1.6 }}>
                  <strong>Alagar Crackers</strong><br />
                  Sankarankovil Rd, Muthugudi,<br />
                  Rajapalayam, Tamil Nadu - 626117
                </div>
              </div>
            </Col>

            <Col lg={4} md={6} className='py-3'>
              <div className='box'>
                <div className='box-icon'>
                  <BiPhoneCall size={36} />
                </div>
                <h4 className='bold text-dark mb-2'>Call & WhatsApp</h4>
                <div className='regular text-muted' style={{ lineHeight: 1.8 }}>
                  <div><a href="tel:+919342113123" className='bold text-danger' style={{ fontSize: '18px' }}>+91 93421 13123</a></div>
                  <small className='text-muted'>Available from 9:00 AM - 10:00 PM</small>
                </div>
              </div>
            </Col>

            <Col lg={4} md={12} className='py-3'>
              <div className='box'>
                <div className='box-icon'>
                  <MdOutlineAlternateEmail size={36} />
                </div>
                <h4 className='bold text-dark mb-2'>Email Inquiry</h4>
                <div className='regular text-muted' style={{ lineHeight: 1.8 }}>
                  <div><a href="mailto:alagarcrackers@gmail.com" className='bold text-dark'>alagarcrackers@gmail.com</a></div>
                  <small className='text-muted'>Drop us a mail for bulk dealer pricing</small>
                </div>
              </div>
            </Col>

            <Col lg={12} className='pt-5'>
              <div style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.033543295169!2d77.55746647450249!3d9.406019982974492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06ea00d83661cb%3A0x8aa40ff4bbb97ea1!2sAlagar%20Fire%20Crackers%20agencies!5e1!3m2!1sen!2sin!4v1727800205472!5m2!1sen!2sin"
                  width="100%"
                  height="450"
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen
                  title="Google Maps Location of Alagar Crackers"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs;